import { render, staticRenderFns } from "./promote-subject.vue?vue&type=template&id=60ed2117&"
import script from "./promote-subject.vue?vue&type=script&lang=js&"
export * from "./promote-subject.vue?vue&type=script&lang=js&"
import style0 from "./promote-subject.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./promote-subject.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports